import { JSX, KeyboardEvent } from "react";

import { SxProps, TextField, Theme } from "@mui/material";

interface ITextFieldSimple {
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  sx?: SxProps<Theme>;
  multiline?: boolean;
  rows?: number;
  error?: boolean;
  disabled?: boolean;
  helperText?: string;
  onBlur?: (value: string) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void;
}
export const TextFieldSimple = ({
  value,
  onChange,
  type,
  sx,
  multiline,
  rows,
  error,
  disabled,
  helperText,
  onBlur,
  onKeyDown,
}: ITextFieldSimple): JSX.Element => {
  const defaultSx: SxProps<Theme> = {};
  return (
    <TextField
      helperText={helperText}
      error={error}
      multiline={multiline}
      rows={rows}
      id="outlined-basic"
      variant="outlined"
      size="small"
      type={type || "text"}
      value={value}
      onBlur={(e) => {
        onBlur?.(e.target.value);
      }}
      onKeyDown={(e) => {
        onKeyDown?.(e);
      }}
      onChange={onChange}
      sx={{ ...defaultSx, ...sx }}
      disabled={disabled}
    />
  );
};
